module.exports = __webpack_public_path__ + "static/image/history/pc/201812.jpg?d9adc6ef";